























import { Component, Vue } from 'vue-property-decorator'
import mainMenu from '@/data/menu'
import MenuItem from './MenuItem.vue'

@Component({
  components: {
    MenuItem
  }
})
export default class Menu extends Vue {
  private readonly menu = mainMenu
}
